import { createSlice } from "@reduxjs/toolkit";
import initialState from "./state";
import { getAllUserAndDepartmentDropdown } from "./actionCreator";

export const shareSlice = createSlice({
  name: "share",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    /*-------------------------------- get share drive Pending State ---------------------------------*/

    builder.addCase(getAllUserAndDepartmentDropdown.pending, (state) => {
      state.loading = true;
      state.error = "";
      state.users = [];
      state.departments = [];
      state.isError = false;
    });

    /*-------------------------------- get share drive fullfiled State ---------------------------------*/
    builder.addCase(
      getAllUserAndDepartmentDropdown.fulfilled,
      (state, action) => {
        state.loading = false;
        state.users = action.payload?.data?.users?.map((user: any) => ({
          ...user,
          label: `${user.first_name} ${user.last_name}`,
          value: user.id,
        }));
        state.departments = action.payload?.data?.roles?.map((role: any) => ({
          ...role,
          label: role.name,
          value: role.id,
        }));
        state.error = "";
        state.isError = false;
      },
    );

    /*-------------------------------- get share drive Rejected State ---------------------------------*/
    builder.addCase(
      getAllUserAndDepartmentDropdown.rejected,
      (state, action) => {
        state.loading = false;
        state.error = action.error.message || "";
        state.isError = true;
      },
    );
  },
});

export default shareSlice.reducer;
